import styled from 'styled-components';
import { colors } from 'spw-theme';
import { Box } from '@mui/material';
import { SpaceCategoryColorDot } from 'spw-components/dialogs/spaces/styles';

export const NavigationButtonsContainer = styled.div`
  width: 48px;
  height: 224px;
  background: ${colors.white};
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  cursor: grab;
`;

export const GrabArea = styled(Box)`
  && {
    cursor: grab;
    height: 16px;
    display: flex;
    flex-direction: row;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    background-color: ${colors.offWhite};
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  img {
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
    user-drag: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
  }
`;
export const GrabAreaImg = styled.img`
  height: 4px;
  width: 11px;
`;
export const LargeGrabArea = styled(GrabArea)`
  && {
    height: 24px;
  }
`;
export const LargeGrabAreaImg = styled.img`
  height: 6px;
  width: 16px;
`;

export const ButtonsContainer = styled.div`
  && {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const NavigationButton = styled(SpaceCategoryColorDot)`
  && {
    cursor: pointer;
    margin-top: 8px;
    &.disabled {
      background: ${colors.offWhite} !important;
    }
    &:hover {
      &.disabled {
        cursor: grab;
      }
    }
  }
`;

export const ScrollToTopButton = styled(SpaceCategoryColorDot)`
  margin-top: 8px;
  cursor: pointer;
  &:hover {
    background: ${colors.backgroundGrey} !important;
  }
  &:hover {
    &.disabled {
      cursor: grab;
      background: ${colors.white} !important;
    }
  }
`;
